import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            let senha = password;
            const response = await axios.post(`${API_BASE_URL}/Usuario/login`, { email, senha });
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('idUsuario', response.data.usuario.id);
            localStorage.setItem('nomeUsuario', response.data.usuario.nome);
            alert('Login bem-sucedido!');
            navigate('/menu');
        } catch (error) {
            alert('Falha no login. Verifique suas credenciais.');
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center vh-100">
            <div className="card p-4 shadow-lg" style={{ width: '100%', maxWidth: '400px' }}>
                <h2 className="text-center mb-4">Login</h2>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label">Email:</label>
                        <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Senha:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary w-100">Entrar</button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage;
